import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ds-hero-wave-background',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="ds-hero-wave">
      <svg class="ds-hero-wave__art" viewBox="0 0 360 220" preserveAspectRatio="none" aria-hidden="true">
        <defs>
          <linearGradient [attr.id]="strokeGradientId" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="var(--ds-hero-wave-stroke-start)" />
            <stop offset="100%" stop-color="var(--ds-hero-wave-stroke-end)" />
          </linearGradient>
          <linearGradient [attr.id]="glowGradientId" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="var(--ds-hero-wave-glow-start)" />
            <stop offset="100%" stop-color="var(--ds-hero-wave-glow-end)" />
          </linearGradient>
        </defs>
        <path
          class="ds-hero-wave__glow"
          [attr.d]="curvePath"
          [attr.stroke]="'url(#' + glowGradientId + ')'"
        />
        <path
          class="ds-hero-wave__stroke"
          [attr.d]="curvePath"
          [attr.stroke]="'url(#' + strokeGradientId + ')'"
        />
      </svg>
      <div class="ds-hero-wave__content">
        <ng-content />
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }

    .ds-hero-wave {
      position: relative;
      height: 100%;
      overflow: hidden;
      background: var(--ds-hero-wave-background);
    }

    .ds-hero-wave__art {
      position: absolute;
      inset: 0;
      display: block;
      width: 100%;
      height: 100%;
      pointer-events: none;
    }

    .ds-hero-wave__glow,
    .ds-hero-wave__stroke {
      fill: none;
      stroke-linecap: round;
      vector-effect: non-scaling-stroke;
    }

    .ds-hero-wave__glow {
      stroke-width: var(--ds-hero-wave-glow-width);
      filter: blur(var(--ds-hero-wave-glow-blur));
    }

    .ds-hero-wave__stroke {
      stroke-width: var(--ds-hero-wave-stroke-width);
    }

    .ds-hero-wave__content {
      position: relative;
      z-index: 1;
      height: 100%;
    }
  `],
})
export class DsHeroWaveBackgroundComponent {
  private static instanceCount = 0;

  readonly curvePath = 'M -10.8 33 C 68.4 6.6, 86.4 154, 187.2 110 C 266.4 74.8, 302.4 30.8, 370.8 81.4';
  readonly strokeGradientId = `dsHeroWaveStroke-${DsHeroWaveBackgroundComponent.instanceCount}`;
  readonly glowGradientId = `dsHeroWaveGlow-${DsHeroWaveBackgroundComponent.instanceCount++}`;
}
